exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video[data-v-b1aa935a]{margin-top:45px}.field .field-control .display[data-v-b1aa935a]{display:block}", ""]);

// exports
